import React from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { splitHtmlString } from '../../../../../utils/window';

function AnimatedText1({
  text,
  setting = {
    duration: 1,
    delay: 0,
    loop: false
  },
  id
}: {
  text: string;
  setting: {
    duration: number;
    delay: number;
    loop: boolean;
  };
  id: string;
}) {
  const container = React.useRef<HTMLParagraphElement>(null);

  const { duration, delay, loop } = setting || {};
  const htmlText = splitHtmlString(text);
  useGSAP(() => {
    const tl = gsap.timeline({ repeat: loop ? -1 : 0, delay, repeatDelay: 0.2, yoyo: loop});
    tl.from('.letter', {
        opacity: 0,
        scale: 4,
        translateZ: 0,
        ease: 'expo.out',
        duration: duration,
        stagger: 0.07
    });
  }, {scope: container, dependencies: [duration], revertOnUpdate: true});

  return (
    <div className="animate-container" id={id} ref={container} dangerouslySetInnerHTML={{ __html: htmlText}}>
    </div>
  );
}

export default AnimatedText1;
